<div [formGroup]="deliveryOnStockDosageFormGroup" class="d-flex gap-10">
    <mat-form-field appearance="outline">
        <mat-label>
            {{ "medicalHistory.modify.prescriptionHex.input.countAnimals" | translate }}
        </mat-label>
        <input [id]="'intTreatingAnimalsNumber' + idHtmlElements" dianaNumberInputCheck [allowNegative]="false"
            [totalDecimalCases]="0" matInput formControlName="treatingAnimalsNumber">
    </mat-form-field>
    <mat-form-field appearance="outline">
        <mat-label>
            {{ "medicalHistory.modify.prescriptionHex.input.dosagePerAnimal" | translate }}
        </mat-label>
        <input [id]="'intAnimalDosis' + idHtmlElements" dianaNumberInputCheck [allowNegative]="false" [totalDecimalCases]="4" matInput
            formControlName="animalDosis">
    </mat-form-field>
    <mat-form-field appearance="outline">
        <mat-label>
            {{ "medicalHistory.modify.dosisModal.dosisValues.input.unit.label" | translate }}
        </mat-label>
        <input matInput formControlName="units" [id]="'intDeliveryOnStockUnits' + idHtmlElements">
    </mat-form-field>
    <mat-form-field appearance="outline">
        <mat-label>
            {{ "medicalHistory.modify.prescriptionHex.input.countDays" | translate }}
        </mat-label>
        <input [id]="'intTreatmentDays' + idHtmlElements" dianaNumberInputCheck [allowNegative]="false" [totalDecimalCases]="0" matInput
            formControlName="treatmentDays">
    </mat-form-field>
</div>
<div class="d-flex">
    @if (deliveryOnStockDosageFormGroup && deliveryOnStockDosageFormGroup.invalid) {
    <span class="error">
        *{{ 'medicalHistory.modify.prescriptionHex.deliveryOnStock.error' | translate }}
    </span>
    }
</div>